import React from 'react';

function ResourceIntro() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 md:pt-40">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="h1 lg:text-4xl mb-4 text-gray-600 font-red-hat-display font-extrabold"><span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-400">Together</span>, we can learn about air pollution</h1>
            <p className="text-lg text-gray-600">
              Take a look at some resources we have found useful over the years.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ResourceIntro;